import { useEffect, useState } from "react";
import Layout from "../assets/component/Layout";
import { Container } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { BASE_URL_FILE } from "./AdmissionApplication";

const BASE_URL = process.env.REACT_APP_API_URL

export default function AllRequests() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchRequests = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(`${BASE_URL}list-forms`, {
        headers: {
          Authorization: token,
        },
      });
      setRequests(response.data.data?.form);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching requests:", err);
      setError("Failed to load requests");
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchRequests();
  }, []);

  const handleStatusChange = async (res, newStatus) => {
    let data = {
      status: newStatus,
      formId: res._id,
      formType: res.document_type
    }
    const token = localStorage.getItem("token");
    try {
      const response = await axios.put(`${BASE_URL}update-form`, data, {
        headers: {
          Authorization: token,
        },
      });
      fetchRequests()
    } catch (error) {
      console.error("Failed to update status:", error);
      alert("Failed to update status");
    }
  };


  return (
    <Layout>
      <section className="Inner-page-layout">
        <div className="">
          <h1>All Requests</h1>

          <div className="engineers-forms-table adding-p-t">
            <Container>
              {loading ? (
                <p>Loading requests...</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : (
                <Table>
                  <thead>
                    <tr>
                      <th>Last Updated Date</th>
                      <th>Form Name</th>
                      <th>View</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {requests?.length ? requests.map((request, index) => (
                      <tr key={request.id || index}>
                        <td>{new Date(request.updatedAt).toLocaleDateString()}</td>
                        <td>{request.document_type}</td>
                        <td>
                          <a href={`${BASE_URL_FILE}${request?.pdf}`} target="_blank" rel="noopener noreferrer">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M5 20h14v-2H5v2zm7-18L5.33 9h3.34v4h4.66v-4h3.34L12 2z"
                                fill="red"
                              />
                            </svg>
                          </a>
                        </td>
                        <td>
                          <Form.Select
                            aria-label="Request status select"
                            value={request.status}
                            onChange={(e) =>
                              handleStatusChange(request, e.target.value)
                            }

                          >
                            <option value="Pending" disabled>Pending</option>
                            <option value="Approved" className={`text-success`}>Approved</option>
                            <option value="Rejected" className={`text-danger`}>Rejected</option>
                          </Form.Select>
                        </td>
                      </tr>
                    )) : null}
                  </tbody>
                </Table>
              )}
            </Container>
          </div>
        </div>
      </section>
    </Layout >
  );
}
